import { NAME } from './constants';

export const HIDE_BANNER = `${NAME}/hide`;
